import React, { useRef, useState } from "react";
import axios from "axios";
import { Button } from "../../../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${sessionStorage.getItem("access_token")}` });

/** Crop an existing product photo: auto-center the subject, or drag a box on the image. */
export const CropImageModal = ({ articleId, index, imageUrl, onDone, onClose }) => {
  const [box, setBox] = useState(null);
  const [drag, setDrag] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const imgRef = useRef(null);

  const pct = (e) => {
    const r = imgRef.current.getBoundingClientRect();
    return {
      x: Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100)),
      y: Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100)),
    };
  };
  const onDown = (e) => { e.preventDefault(); setDrag(pct(e)); setBox(null); };
  const onMove = (e) => {
    if (!drag) return;
    const p = pct(e);
    setBox({ l: Math.min(drag.x, p.x), t: Math.min(drag.y, p.y), r: Math.max(drag.x, p.x), b: Math.max(drag.y, p.y) });
  };
  const onUp = () => setDrag(null);

  const submit = async (payload) => {
    setBusy(true);
    setError("");
    try {
      const res = await axios.post(`${API}/articles/${articleId}/crop-image`, { index, ...payload }, { headers: authHeaders() });
      onDone(res.data.images_url);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3" data-testid="crop-modal">
      <div className="bg-white border-2 border-emerald-300 rounded-2xl shadow-lg w-full max-w-lg p-4">
        <div className="flex justify-between items-center mb-2">
          <h3 className="font-bold text-gray-900">✂️ Ritaglia foto</h3>
          <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-900 text-xl leading-none" data-testid="crop-close">×</button>
        </div>
        <p className="text-xs text-gray-500 mb-3">
          <strong>Centra automaticamente</strong> toglie i bordi vuoti e rende la foto quadrata con il modellino al centro. Oppure trascina col mouse sull'immagine per scegliere l'area da tenere.
        </p>
        <div className="relative select-none bg-gray-100 rounded-lg overflow-hidden" onMouseDown={onDown} onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp} data-testid="crop-canvas">
          <img ref={imgRef} src={imageUrl} alt="" className="w-full max-h-[45vh] object-contain block cursor-crosshair" draggable={false} data-testid="crop-image" />
          {box && (
            <div className="absolute border-2 border-pink-500 bg-pink-500/15 pointer-events-none" data-testid="crop-box"
              style={{ left: `${box.l}%`, top: `${box.t}%`, width: `${box.r - box.l}%`, height: `${box.b - box.t}%` }} />
          )}
        </div>
        {error && <p className="text-xs text-red-600 mt-2" data-testid="crop-error">{error}</p>}
        <div className="flex flex-wrap justify-end gap-2 mt-4">
          <Button type="button" variant="outline" onClick={onClose} disabled={busy} data-testid="crop-cancel">Annulla</Button>
          <Button type="button" onClick={() => submit({ mode: "auto" })} disabled={busy} className="bg-sky-600 hover:bg-sky-700 text-white" data-testid="crop-auto-btn">
            {busy ? "Elaboro…" : "🎯 Centra automaticamente"}
          </Button>
          <Button type="button" onClick={() => box && submit({ box: [box.l, box.t, box.r, box.b] })} disabled={busy || !box || box.r - box.l < 5 || box.b - box.t < 5}
            className="bg-pink-600 hover:bg-pink-700 text-white" data-testid="crop-manual-btn">
            ✂️ Ritaglia area selezionata
          </Button>
        </div>
      </div>
    </div>
  );
};
